import Resource from './common/resource';

class CustomObjects extends Resource {
  path = 'custom/objects';
}

export default CustomObjects;
